import React from 'react'

const LoadingBox: React.FC = () => {
    return (
        <div className="center loader">
            <i className="fa fa-spinner fa-spin fa-fw"></i>
        </div>
    )
}

export default LoadingBox;